import React, { useState, useEffect } from "react";
import {
  CurrentAddress,
  PermanentAddress as PermanentAddressDetails,
  UserProfileType,
} from "../../../../redux/auth/authTypes";
import { useLocation } from "react-router-dom";
import { STATES_LIST } from "../../../../constant/stateListConstants";
import Select from "react-select";
import { countryCode } from "../../../../constant/countryCode";

type AppProps = {
  data: PermanentAddressDetails;
  isEdit?: boolean | string;
  setProfileForm: any;
  handlePermanetAddressDetails: (data: any) => void;
  addressData: CurrentAddress;
  setSameAddress: any;
  sameAddress: boolean;
  onMenuClose: () => void;
  Option: any;
  countrySelectedList: any;
  countryFetching: boolean;
  setLoadCondition: React.Dispatch<React.SetStateAction<boolean>>;
  setCountryText: React.Dispatch<React.SetStateAction<string>>;
  setCountryOffset: React.Dispatch<React.SetStateAction<number>>;
  countrylimit: number;
  finalCountry: any;
  handleChangeCountry: (data: any) => void;
  handleChangeState: (data: any) => void;
  finalStateList: any;
  stateFetching: boolean;
  setStateText: React.Dispatch<React.SetStateAction<string>>;
  setStateOffset: React.Dispatch<React.SetStateAction<number>>;
  isState: boolean | null;
  isCity: boolean | null;
  addressState: any;
  finalCityList: any;
  selectedCityList: any;
  handleChangeCity: (data: any) => void;
  setCityOffset: React.Dispatch<React.SetStateAction<number>>;
  setCityText: React.Dispatch<React.SetStateAction<string>>;
  finalStateAddressList:any;
  stateFetchingPermanentAddress:boolean
  setStateAddressText:React.Dispatch<React.SetStateAction<string>>;
  setStateAddressOffset:React.Dispatch<React.SetStateAction<number>>;
  isStatePermanentAddress:boolean |null
  finalCityAddressList:any
  cityFetchingPermanentAddress:boolean
  setCityAddressText:React.Dispatch<React.SetStateAction<string>>;
  setCityAddressOffset:React.Dispatch<React.SetStateAction<number>>;
  isCityPermanentAddress:boolean |null
};
const PermanentAddress = ({
  data,
  isEdit,
  setProfileForm,
  handlePermanetAddressDetails,
  addressData,
  setSameAddress,
  sameAddress,
  onMenuClose,
  Option,
  countrySelectedList,
  countryFetching,
  setLoadCondition,
  setCountryText,
  setCountryOffset,
  countrylimit,
  finalCountry,
  handleChangeCountry,
  handleChangeState,
  finalStateList,
  stateFetching,
  setStateText,
  setStateOffset,
  isState,
  isCity,
  addressState,
  finalCityList,
  selectedCityList,
  handleChangeCity,
  setCityOffset,
  setCityText,
  finalStateAddressList,
  stateFetchingPermanentAddress,
  setStateAddressText,
  setStateAddressOffset,
  isStatePermanentAddress,
  finalCityAddressList,
  cityFetchingPermanentAddress,
  setCityAddressText,
  setCityAddressOffset,
  isCityPermanentAddress
}: AppProps) => {
  const { pathname } = useLocation();
  // const [sameAddress, setSameAddress] = useState(false);

  const [editPageAutoFilled, setEditPageAutoFilled] = useState(false);
  const [countryData, setCountryData] = useState([]);
  useEffect(() => {
    const countryDropdown: any = countryCode?.map((e: any) => {
      return {
        value: e.name,
        label: e.name,
      };
    });
    setCountryData(countryDropdown);
  }, []);
  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setCountryOffset((prv: any) => prv + countrylimit);
  };
  const checkBottomState = (e: any) => {
    setLoadCondition(false);
    setStateAddressOffset((prv: any) => prv + countrylimit);
  };
  const checkBottomCity = (e: any) => {
    setLoadCondition(false);
    setCityAddressOffset((prv: any) => prv + countrylimit);
  };
  useEffect(() => {
    if (pathname?.includes("edit") && data && addressData) {
      let currentAddressData = Object.values(data);
      let permanentAddressData = Object.values(addressData);
      if (
        currentAddressData[0] === permanentAddressData[0] &&
        currentAddressData[1] === permanentAddressData[1] &&
        currentAddressData[2]?.value === permanentAddressData[2]?.value &&
        currentAddressData[3]?.value === permanentAddressData[3]?.value &&
        currentAddressData[4] === permanentAddressData[4] &&
        currentAddressData[5]?.value === permanentAddressData[5]?.value 
      ) {
        setEditPageAutoFilled(true);
        setSameAddress(true);
      } else {
        setSameAddress(false);
        setEditPageAutoFilled(false);
      }
    }
  }, [data, addressData]);
  useEffect(() => {
    if (sameAddress) {
      setProfileForm((prv: UserProfileType) => {
        return {
          ...prv,
          user_details: {
            ...prv.user_details,
            permanent_address: {
              address_line1: addressData?.address_line1,
              address_line2: addressData?.address_line2,
              city: addressData?.city,
              state: addressData?.state,
              postal_code: addressData?.postal_code,
              country: addressData?.country,
            },
          },
        };
      });
    }
  }, [sameAddress]);
  return (
    <div className="form-group">
      <h6>PERMANENT ADDRESS</h6>
      <div
        style={{
          textAlign: "left",
          display: "flex",
          marginTop: "11px",
          gap: "7px",
        }}
      >
        <input
          type="checkbox"
          style={{
            width: "19px",
            height: "19px",
            backgroundColor: "red",
            accentColor: " #dd4433",
          }}
          key={Math.random()}
          onChange={() => {
            setSameAddress(!sameAddress);
          }}
          className="checkbox"
          defaultChecked={sameAddress}
        />
        <span>Same as current address</span>
      </div>
      <div className="row mt-2">
        <div className="col-md-6">
          <label htmlFor="aboutMe">Address Line 1</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="address_line1"
              // disabled={!isEdit}
              disabled={sameAddress}
              onChange={handlePermanetAddressDetails}
              value={data?.address_line1 || ""}
            />
          </div>
        </div>
        <div className="col-md-6">
          <label htmlFor="aboutMe">Address Line 2</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="address_line2"
              //   disabled={!isEdit}
              disabled={sameAddress}
              onChange={handlePermanetAddressDetails}
              value={data?.address_line2 || ""}
            />
          </div>
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-md-3">
          <label htmlFor="aboutMe">Postal Code</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="postal_code"
              //   disabled={!isEdit}
              disabled={sameAddress}
              onChange={handlePermanetAddressDetails}
              value={data?.postal_code || ""}
            />
          </div>
        </div>
        <div className="col-md-3">
          <label htmlFor="country">Country</label>
          <Select<any, false>
            onMenuClose={onMenuClose}
            components={{ Option }}
            isSearchable={true}
            inputProps={{ autoComplete: "nope" }}
            placeholder={"Select country"}
            isLoading={countryFetching}
            onMenuScrollToBottom={(e: any) => checkBottom(e)}
            options={countrySelectedList}
            onChange={(e: any) => {
              if (e) {
                setProfileForm((prv: UserProfileType) => {
                  return {
                    ...prv,
                    user_details: {
                      ...prv.user_details,
                      permanent_address: {
                        ...prv.user_details.permanent_address,
                        // ...prv,user_details.personal_details,
                        country: {
                          label: e?.label,
                          value: e?.value,
                        },
                        state: {
                          label: "Select",
                          value: null,
                        },
                        city: {
                          label: "Select",
                          value: null,
                        },
                      },
                    },
                  };
                });
              }
              handleChangeCountry(e);
            }}
            value={data?.country}
            onInputChange={(e) => {
              setLoadCondition(false);
              setCountryText(e);
              setCountryOffset(0);
            }}
            isDisabled={sameAddress}

          />
        </div>
        {data?.country?.value && isStatePermanentAddress && (
          <div className="col-md-3">
            {isStatePermanentAddress && <label htmlFor="state">State </label>}

            {isStatePermanentAddress && (
              <Select<any, false>
                inputProps={{ autoComplete: "nope" }}
                onMenuClose={onMenuClose}
                components={{ Option }}
                isSearchable={true}
                placeholder={"Select state"}
                options={finalStateAddressList}
                isLoading={stateFetchingPermanentAddress}
                onMenuScrollToBottom={(e: any) => checkBottomState(e)}
                // value={selectBranch}
                onChange={(e: any) => {
                  if (e) {
                    setProfileForm((prv: UserProfileType) => {
                      return {
                        ...prv,
                        user_details: {
                          ...prv.user_details,
                          permanent_address: {
                            ...prv.user_details.permanent_address,
                            // ...prv,user_details.personal_details,
                            state: {
                              label: e?.label,
                              value: e?.value,
                            },
                            city: {
                              label: "Select",
                              value: null,
                            },
                          },
                        },
                      };
                    });
                  }
                  handleChangeState(e);
                }}
                value={data?.state}
                onInputChange={(e) => {
                  setLoadCondition(false);
                  setStateAddressText(e);
                  setStateAddressOffset(0);
                }}
                isDisabled={sameAddress}

              />
            )}
            {/* </div> */}
          </div>
        )}
        {((isStatePermanentAddress === true && data?.state?.value && isCityPermanentAddress) ||
          (isStatePermanentAddress === false && data?.country?.value && isCityPermanentAddress)) && (
          <div className="col-md-3">
            <form>
              <div className="form-group">
                <div>
                  <label htmlFor="City" className={"active"}>
                    City
                  </label>

                  <Select
                    onMenuClose={onMenuClose}
                    components={{ Option }}
                    isSearchable={true}
                    options={finalCityAddressList}
                    isLoading={cityFetchingPermanentAddress}
                    value={
                      data?.city
                    }
                    onMenuScrollToBottom={(e: any) => checkBottomCity(e)}
                    // onChange={(e) => handleChangeCity(e)}
                    onChange={(e: any) => {
                      if (e) {
                        setProfileForm((prv: UserProfileType) => {
                          return {
                            ...prv,
                            user_details: {
                              ...prv.user_details,
                              permanent_address: {
                                ...prv.user_details.permanent_address,
                                // ...prv,user_details.personal_details,
                                city: {
                                  label: e?.label,
                                  value: e?.value,
                                },
                              },
                            },
                          };
                        });
                      }
                      handleChangeCity(e);
                    }}
                    onInputChange={(e) => {
                      setLoadCondition(false);
                      setCityAddressText(e);
                      setCityAddressOffset(0);
                    }}
                    isDisabled={sameAddress}

                  />
                </div>
              </div>
            </form>
          </div>
        )}
       
      </div>
    </div>
  );
};

export default PermanentAddress;
